module.exports = __webpack_public_path__ + "static/media/ios-heart-dislike.a335ca3d.svg";